export default __webpack_public_path__ + "cd021aa75074bf14555113c736f7b0ea.png";